import { FlowExtractPtBr } from "./flow-extract-pt-br";

export const FLOW_EXTRACT_FR_FR: FlowExtractPtBr = {
	table: {
		description: "Description",
		initialValue: "Solde Initial:",
		finalValue: "Solde Final:",
		in: "Total des Entrées:",
		out: "Total des Sorties:",
		value: "Valeur",
		item: {
			liquidationDate: "DATE DE RÈGLEMENT",
			referenceDate: "DATE DE RÉFÉRENCE",
			groupName: "TYPE",
			type: "TYPE",
			originDestination: "ORIGINE/DESTINATION",
			category: "CATÉGORIE",
			observation: "OBSERVATION",
			value: "MONTANT",
		},
	},
	excel: {
		title: "Rapport d'Extrait",
		grouped: {
			day: "par jour",
			month: "par mois",
			type: "par type",
			category: "par catégorie",
		},
	},
	search: "Rechercher par...",
	today: "Aujourd'hui",
	yesterday: "Hier",
	filter: {
		perType: "Par Type",
	},
	accountRequired: "Un compte est requis.",
	anticipated: "Anticipé",
	normalValue: "Valeur Normale",
	anticipatedValue: "Valeur Anticipée",
	dateTypeLabel: "Filtrer par",
	competence: "Compétence",
	liquidation: "Liquidation",
	apply: "Appliquer",
};
